__turbopack_context__.v({
  "border-drag-over": "UgZs4q_border-drag-over",
  "controls": "UgZs4q_controls",
  "dropzone": "UgZs4q_dropzone",
  "error": "UgZs4q_error",
  "infoFiletypes": "UgZs4q_infoFiletypes",
  "infoLabel": "UgZs4q_infoLabel",
  "input": "UgZs4q_input",
  "labelBox": "UgZs4q_labelBox",
  "optional": "UgZs4q_optional",
  "previewContainer": "UgZs4q_previewContainer",
  "previewFile": "UgZs4q_previewFile",
  "previewImage": "UgZs4q_previewImage",
  "previewItem": "UgZs4q_previewItem",
  "removeButton": "UgZs4q_removeButton",
  "uploadFieldContainer": "UgZs4q_uploadFieldContainer",
});
